import {
  Claim,
  Task,
  ProjectPlanType,
  Invoice,
  Attachment,
  TriageDetails,
} from "../../types";
export const SET_DATA = "SET_DATA";
export const SET_TASKS = "SET_TASKS";
export const SET_PROJECTPLAN = "SET_PROJECTPLAN";
export const SET_INVOICES = "SET_INVOICES";
export const SET_ATTACHMENTS = "SET_ATTACHMENTS";
export const SET_TRIAGE = "SET_TRIAGE";

interface SetDataAction {
  type: typeof SET_DATA;
  data: Claim[];
}

interface SetTasksAction {
  type: typeof SET_TASKS;
  data: Task[];
}

interface SetProjectPlanAction {
  type: typeof SET_PROJECTPLAN;
  data: ProjectPlanType[];
}

interface SetInvoicesAction {
  type: typeof SET_INVOICES;
  data: Invoice[];
}

interface SetAttachmentsAction {
  type: typeof SET_ATTACHMENTS;
  data: Attachment[];
}

interface SetTriageAction {
  type: typeof SET_TRIAGE;
  data: TriageDetails;
}

export type DataActionType =
  | SetDataAction
  | SetTasksAction
  | SetProjectPlanAction
  | SetInvoicesAction
  | SetAttachmentsAction
  | SetTriageAction;
